<template>
  <div class="login_up" :id="nodeName">
    <!-- <div class="registerBox" v-show="isRegisterBox"> -->
    <h4>{{title}}</h4>
    <el-form v-show="registrationMethod" :model="ruleForm" status-icon :rules="rules" ref="ruleForm" label-width="0px"
      class="ruleForm">
      <p style="float:left;paddingLeft:10px">手机号</p>
      <el-form-item label prop="loginName">
        <el-input autocomplete="off" v-model.number="ruleForm.loginName"></el-input>
      </el-form-item>
      <p style="text-align: left;paddingLeft:10px">验证码</p>
      <el-form-item label prop="numCode" class="verification">
        <el-col :span="13">
          <el-input v-model="ruleForm.numCode" autocomplete="off"></el-input>
        </el-col>
        <el-col class="line" :span="1">&nbsp;</el-col>
        <el-col :span="10">
          <button type="button" @click="getVerificationCode('ruleForm')" :disabled="disabled">{{verificationCode}}
            <span v-if="ver">秒后重试</span>
          </button>
        </el-col>
      </el-form-item>
      <p style="float:left;paddingLeft:10px">设置新密码</p>
      <el-form-item label prop="password">
        <el-input type="password" v-model="ruleForm.password" autocomplete="off" show-password></el-input>
      </el-form-item>
      <!-- <p class="passHint" style="float:left">*密码长度不能超过16个字符</p> -->
      <el-form-item>
        <el-button class="submitBut" type="primary" @click="submitForm('ruleForm')">确定</el-button>
      </el-form-item>
    </el-form>
    <el-form v-show="!registrationMethod" :model="ruleFormEmail" status-icon :rules="rulesEmail" ref="ruleFormEmail"
      label-width="0px" class="ruleForm">
      <p style="float:left;paddingLeft:10px">邮箱</p>
      <el-form-item label prop="email">
        <el-input autocomplete="off" v-model="ruleFormEmail.email"></el-input>
      </el-form-item>
      <p style="text-align: left;paddingLeft:10px">验证码</p>
      <el-form-item label prop="numCode" class="verification">
        <el-col :span="13">
          <el-input v-model="ruleFormEmail.numCode" autocomplete="off"></el-input>
        </el-col>
        <el-col class="line" :span="1">&nbsp;</el-col>
        <el-col :span="10">
          <button type="button" @click="getVerificationCode('ruleForm')" :disabled="disabled">{{verificationCode}}
            <span v-if="ver">秒后重试</span>
          </button>
        </el-col>
      </el-form-item>
      <p style="float:left;paddingLeft:10px">设置新密码</p>
      <el-form-item label prop="password">
        <el-input type="password" v-model="ruleFormEmail.password" autocomplete="off" show-password></el-input>
      </el-form-item>
      <!-- <p class="passHint" style="float:left">*密码长度不能超过16个字符</p> -->
      <el-form-item>
        <el-button class="submitBut" type="primary" @click="submitForm('ruleForm')">确定</el-button>
      </el-form-item>
    </el-form>
    <div class="previousStep">
      <span @click="iswitch">{{titleName}}</span>
      <span @click="goback">返回登录</span>
    </div>
    <!-- </div> -->
  </div>
</template>

<script>
import { setTimeout } from "timers";
import md5 from "js-md5";
// import myTitle from '@/common/title.vue'

export default {
  name: "login_up",
  data () {
    var username = (rule, value, callback) => {
      let reg = /^1\d{10}$/;
      if (!value) {
        return callback(new Error("手机号不能为空"));
      }
      if (!reg.test(value)) {
        return callback(new Error("手机号不正确"));
      }
      callback();
    };
    var userEmail = (rule, value, callback) => {
      let email = /\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*/;
      if (!value) {
        return callback(new Error("邮箱不能为空"));
      }
      if (!email.test(value)) {
        return callback(new Error("邮箱不正确"));
      }
      callback();
    };
    var validatePass = (rule, value, callback) => {
      if (value === "") {
        return callback(new Error("请输入密码"));
      } else if (value.length < 6) {
        callback(new Error("密码长度不能小于6个字符"));
      } else if (value.length > 16) {
        callback(new Error("密码长度不能超过16个字符"));
      }
      callback();
    };
    var verify = (rule, value, callback) => {
      if (!value) {
        return callback(new Error("验证码不能为空"));
      }
      callback();
    };
    return {
      ruleForm: {
        loginName: "",
        password: "",
        verification: "",
        numCode: "",
        _load: false
      },
      rules: {
        loginName: [{ required: true, validator: username, trigger: "blur" }],
        password: [{ validator: validatePass, trigger: "blur" }],
        numCode: [{ required: true, message: "请输入短信验证码", trigger: "blur" }],
        verification: [{ validator: verify, trigger: "blur" }]
        // age: [{ validator: checkAge, trigger: "blur" }]
      },
      ruleFormEmail: {
        email: "",
        password: "",
        verification: "",
        numCode: "",
        _load: false
      },
      rulesEmail: {
        email: [{ required: true, validator: userEmail, trigger: "blur" }],
        password: [{ validator: validatePass, trigger: "blur" }],
        numCode: [{ required: true, message: "请输入短信验证码", trigger: "blur" }],
        verification: [{ validator: verify, trigger: "blur" }]
      },
      verificationCode: "获取验证码",
      disabled: false,

      ver: false,
      nodeName: "",
      registrationMethod: true,// 找回方式
    };
  },
  computed: {
    title () {
      return this.registrationMethod ? "手机号找回密码" : "邮箱找回密码"
    },
    titleName () {
      return this.registrationMethod ? "邮箱找回密码" : "手机号找回密码"
    },
  },
  created () {
    this.nodeName = process.env.VUE_APP_NAME;
  },
  methods: {
    // 切换找回方式
    iswitch () {
      if (this.registrationMethod) {
        this.$refs['ruleFormEmail'].resetFields();
        this.$refs['ruleForm'].resetFields();
        this.registrationMethod = !this.registrationMethod
      } else {
        this.$refs['ruleFormEmail'].resetFields();
        this.$refs['ruleForm'].resetFields();
        this.registrationMethod = !this.registrationMethod
      }
    },
    // 返回登录
    goback () {
      this.$emit("func", 0)
      // this.$router.go(-1)
    },
    submitForm () {
      let verify = true
      let that = this;
      if (this.registrationMethod) {
        this.$refs.ruleForm.validateField(["loginName", "numCode", "password"], errTip => {
          if (errTip) {
            // 会调用多次    numCode: '',

            verify = false;
            return
          }
        });
        if (verify) {
          let params = {
            loginPhone: this.ruleForm.loginName,
            password: md5(this.ruleForm.password),
            verificationCode: this.ruleForm.numCode
          }
          this.catReq1Service("/user/forgetPassword", params) // /api/v1/user/update
            .then(response => {
              if (!response.success) {
                return;
              }
              that.$emit("func", 0)
              // that.$router.push({ name: "login_in" });
            })
            .catch(error => {
            });
        }

      } else {
        this.$refs.ruleFormEmail.validateField(["email", "numCode", "password"], errTip => {
          if (errTip) {
            // 会调用多次
            verify = false;
          }
        });
        if (verify) {
          let params = {
            loginPhone: this.ruleFormEmail.email,
            password: md5(this.ruleFormEmail.password),
            verificationCode: this.ruleFormEmail.numCode,
          }

          this.catReq1Service("/user/forgetPassword", params) // /api/v1/user/update
            .then(response => {
              if (!response.success) {
                return;
              }
              that.$emit("func", 0)
              // that.$router.push({ name: "login_in" });
            })
            .catch(error => {
            });
        }

      }

    },
    // 获取验证码
    getVerificationCode () {
      var verify = true;
      if (this.registrationMethod) {
        this.$refs.ruleForm.validateField(["loginName"], errTip => {
          if (errTip) {
            // 会调用多次
            verify = false;
          }
        });
        if (verify) {
          this.ver = true // 显示span
          let timeCounter;
          this.disabled = true;
          this.verificationCode = 60;
          if (this.verificationCode < 0) {
            clearTimeout(timeCounter);
            this.disabled = false;
            this.ver = false
            this.verificationCode = "获取验证码";
          }
          timeCounter = setInterval(() => {
            this.verificationCode--;

            if (this.verificationCode < 0) {
              clearTimeout(timeCounter);
              this.disabled = false;
              this.ver = false
              this.verificationCode = "重新获取验证码";

            }
          }, 1000);
          let params = {
            loginPhone: this.ruleForm.loginName
          }
          this.catReq1Service("/user/send_verifyCode", params).then(response => {
            if (!response.success) {
              this.disabled = false;
              this.verificationCode = 0
              this.verificationCode = "获取验证码";
              clearTimeout(timeCounter);
              this.ver = false
              return;
            }
            callback && callback(this.scopedForm);
          })
            .catch(error => {


            });
        }

      } else {
        this.$refs.ruleFormEmail.validateField(["email"], errTip => {
          if (errTip) {
            // 会调用多次
            verify = false;
          }
        });
        if (verify) {
          this.ver = true // 显示span
          let timeCounter;
          this.disabled = true;
          this.verificationCode = 60;
          if (this.verificationCode < 0) {
            clearTimeout(timeCounter);
            this.disabled = false;
            this.ver = false
            this.verificationCode = "获取验证码";
          }
          timeCounter = setInterval(() => {
            this.verificationCode--;

            if (this.verificationCode < 0) {
              clearTimeout(timeCounter);
              this.disabled = false;
              this.ver = false
              this.verificationCode = "重新获取验证码";

            }
          }, 1000);
          let params = {
            email: this.ruleFormEmail.email,
            platformType: 0
          }
          this.catReq1Service("/user/send_email_code", params).then(response => {
            if (!response.success) {
              this.disabled = false;
              this.verificationCode = 0
              this.verificationCode = "获取验证码";
              clearTimeout(timeCounter);
              this.ver = false
              return;
            }
            callback && callback(this.scopedForm);
          })
            .catch(error => {


            });
        }
      }

    }
  }
};
</script>
<style lang="less" scoped>
#drill {
  h4 {
    color: rgba(33, 71, 145, 1);
  }
  .ruleForm {
    button {
      background: rgba(41, 185, 147, 1);
      border: 0px;
      color: white;
    }
    /deep/.el-input__inner {
      color: rgba(76, 129, 184, 1);
    }
    .submitBut {
      background: rgba(49, 111, 209, 1);
    }
  }
}
.login_up {
  // width: 284px;
  // height: 370px;
  background: rgba(255, 255, 255, 1);
  // box-shadow: 0px 10px 10px 0px rgba(137, 137, 137, 0.13);
  border-radius: 10px;
  padding: 70px 80px 0 80px;
  // padding: 50px;
  // position: absolute;
  // top: 50%;
  // left: 50%;
  // transform: translate(-50%, -50%);
  h4 {
    text-align: center;
    font-size: 18px;
    font-family: Microsoft YaHei;
    font-weight: bold;
    color: rgba(0, 0, 0, 1);
  }
  .ruleForm {
    margin-top: 30px;
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: rgba(51, 51, 51, 1);
    p {
      margin-bottom: 5px;
    }
    /deep/.el-input__inner {
      height: 36px;
      line-height: 36px;
      border: 1px solid rgba(192, 192, 192, 1);
      border-radius: 2px;
    }
    .verification {
      button {
        // position: relative;
        // left: 0px;
        width: 98%;
        height: 34px;
        background: #5589eb;
        // border: 1px solid #454545;
        border: none;
        border-radius: 2px;
        color: white;
      }
      // button:hover {
      //   background: #f1f1f1;
      //   border: 1px solid #454545;
      //   color: #454545;
      // }
      // button:active {
      //   background: #454545;
      //   color: #ffffff;
      // }
    }
    button {
      width: 100%;
      height: 36px;
      background: #216fe5;
      border: none;
      // border-radius: 18px;
      line-height: 0px;
    }
    // button:hover {
    //   background: #3e3e3e;
    // }
    // button:press {
    //   background: #333333;
    // }
    .register {
      background: #454545;
      border: 1px solid rgba(192, 192, 192, 1);
      color: rgba(69, 69, 69, 1);
    }
    .el-form-item {
      margin-bottom: 20px;
    }
    .passHint {
      position: relative;
      top: -12px;
    }
  }
}
.previousStep {
  width: 65%;
  display: flex;
  justify-content: space-between;
  position: absolute;
  left: 79px;
  font-size: 14px;
  color: #454545;
  margin-top: -12px;
  span {
    cursor: pointer;
  }
  span::after {
    content: attr(data-desc);
  }
}
</style>